module.exports = __webpack_public_path__ + "static/sports1-3061076a7e51c558bd9cc011fdf540fb.gif";